import React, { useCallback } from 'react';
import { useEventInfo } from '@shared/utils/eventInfo';
import { useGuestGuideTelemetry } from '../GuestGuideTelemetry';
import { useTranslation } from '@shared/core';
import { GuestGuideActionButton } from '../GuestGuideActionButton';
import { useHotelRoutePaths } from '@apps/guest/routes/HotelBooking/HotelBooking.routes';
import { HotelBed } from '@withjoy/joykit/icons';

type HotelDealsActionProps = Readonly<{
  isAttending: boolean;
}>;

export const HotelDealsAction: React.FC<HotelDealsActionProps> = ({ isAttending }) => {
  const { eventHandle } = useEventInfo();
  const telemetry = useGuestGuideTelemetry();
  const { tq } = useTranslation('guestGuide');
  const hotelRoutePaths = useHotelRoutePaths();

  // This could be enhanced with feature flags or other business logic in the future

  const handleClick = useCallback(() => {
    telemetry.clickBrowseHotels();
  }, [telemetry]);

  return (
    <GuestGuideActionButton
      icon={<HotelBed size={32} />}
      as="a"
      href={hotelRoutePaths.bookYourStay.buildRelativeUrl(eventHandle || '', {
        utm_campaign: 'guest_guide',
        utm_medium: 'web',
        utm_source: 'guest_guide_guest_site',
      })}
      onClick={handleClick}
    >
      {isAttending ? tq`Book Event-Exclusive Stays` : tq`See Event-Exclusive Stays`}
    </GuestGuideActionButton>
  );
};
